import { MappingIdentifier } from 'src/containers/ProjectDiagram/types/data';
import { LinkData } from 'src/containers/ProjectDiagram/types/model';
import {
  isMapping,
  isRelationshipMapping,
} from 'src/containers/ProjectDiagram/utils/data';
import { Project, ProjectsState } from 'src/store/state/projects';
import { ReduxState } from 'src/store/types';

/**
 * * on {@link MappingIdentifier} converts empty string base IRIs to null
 */
// prevState must be typed as `any` since it's an older version of the Redux State
export const v40 = (prevState: any): ReduxState => {
  const nextState = { ...prevState };

  if (nextState.projects) {
    nextState.projects = v40Projects(prevState.projects);
  }

  return nextState;
};

const v40Projects = (prevProjectsState: any): ProjectsState => {
  const projectsById: Record<string, Project> = {};

  Object.entries(
    prevProjectsState.projectsById as Record<string, Project>
  ).forEach(([projectId, project]) => {
    const { linkDataArray } = project.diagram.model;
    const updatedLinkDataArray = linkDataArray.map<LinkData>((linkData) => {
      if (isMapping(linkData)) {
        const primaryIdentifier: MappingIdentifier = {
          ...linkData.primaryIdentifier,
          baseIri: linkData.primaryIdentifier.baseIri || null,
        };
        return {
          ...linkData,
          primaryIdentifier,
        };
      }
      if (isRelationshipMapping(linkData)) {
        if (linkData.fromPrimaryIdentifier) {
          const fromPrimaryIdentifier: MappingIdentifier = {
            ...linkData.fromPrimaryIdentifier,
            baseIri: linkData.fromPrimaryIdentifier.baseIri || null,
          };
          return {
            ...linkData,
            fromPrimaryIdentifier,
          };
        }
        if (linkData.toPrimaryIdentifier) {
          const toPrimaryIdentifier: MappingIdentifier = {
            ...linkData.toPrimaryIdentifier,
            baseIri: linkData.toPrimaryIdentifier.baseIri || null,
          };
          return {
            ...linkData,
            toPrimaryIdentifier,
          };
        }
      }
      return linkData;
    });

    projectsById[projectId] = {
      ...project,
      diagram: {
        ...project.diagram,
        model: {
          ...project.diagram.model,
          linkDataArray: updatedLinkDataArray,
        },
      },
    };
  });

  return { ...prevProjectsState, projectsById };
};
